import React from 'react';
import * as styles from './PostStateBarTooltip.module.scss';
import Button from '../../components/Button';
import LargeTooltip from '../../components/LargeTooltip';
import SVGIcon from '../../components/SVGIcon';
import { gql } from '../../graphql/generated/gql';
import type { DocumentType } from '../../graphql/generated/gql';
import { PostType } from '../../graphql/generated/graphql';
import newTabIcon from '../../icons/non-prefilled/16x16/newTab.svg';

const POST_FRAGMENT = gql(`
  fragment PostStateBarTooltip_post on Post {
    id
    type
  }
`);

interface PostStateBarTooltipProps {
  post: DocumentType<typeof POST_FRAGMENT>;
  anchorElement: HTMLElement | null;
  children: React.ReactNode;
}

const PostStateBarTooltip = ({
  post,
  children,
  anchorElement,
}: PostStateBarTooltipProps) => {
  const tooltipContent = (() => {
    if (post.type === PostType.Template) {
      return (
        <>
          <LargeTooltip.Heading>Templatized post</LargeTooltip.Heading>
          <div className={styles.tooltipContent}>
            Create new posts from this template’s contents
          </div>
          <Button
            variant="secondary"
            size="small"
            className={styles.tooltipButton}
            newTab
            to="https://help.slab.com/en/articles/4281672-post-templates"
          >
            Learn more
            <SVGIcon size={12}>{newTabIcon}</SVGIcon>
          </Button>
        </>
      );
    }
    return null;
  })();

  return (
    <LargeTooltip
      content={tooltipContent}
      anchorElement={anchorElement}
      placement="bottom"
    >
      <div>{children}</div>
    </LargeTooltip>
  );
};

export default PostStateBarTooltip;
